var classes = {"twoUpFeaturedCardsModuleRoot":"PFxhG","twoUpFeaturedCardsModuleRootSpacious":"_0RFRp","twoUpFeaturedCardsCardsWrapper":"XllYU","twoUpFeaturedCardsCardsGridColumnSpacious":"WSsrT","twoUpFeaturedCardsCardsWrapperSpacious":"GA9Al"};

export { classes as default };
